module.exports = __webpack_public_path__ + "img/logo.3406e224.jpg";